import classNames from "classnames";
import { FC } from "react";

import { Typography } from "@/shared/ui";

import styles from "./switch.module.scss";
import { SwitchProps } from "./switch.types";

const Switch: FC<SwitchProps> = ({ value, label, reverseMarkup, disabled, className, onChange }) => {
  const handleToggle = () => {
    onChange(!value);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames(
        styles.switchContainer,
        reverseMarkup && styles.reverse,
        disabled && styles.disabled,
        className
      )}
      onClick={handleToggle}
    >
      <div className={classNames(styles.switch, value && styles.active)}>
        <div className={classNames(styles.switchCircle, value && styles.active)}></div>
      </div>
      <Typography variant="caption-1">{label}</Typography>
    </div>
  );
};

export { Switch };
